import styled from '@emotion/styled';
import colours from '~/utils/colours';

const FieldError = styled.div`
  font-size: 12px;
  color: ${colours.red};
`;

export default FieldError;
